export default __webpack_public_path__ + "static/blob5-d7648cc47266bd734e790002f4a305df.svg";